import React, { useEffect } from "react";
import styles from "./accessDenied.module.scss";
import { withTranslation } from "react-i18next";
import FordLogo from "../../common/FordLogo";
import { invalidateSession } from "../../common/InvalidateSession";

const AccessDeniedAsNscNotOnboarded = (props) => {
  useEffect(() => {
    props.history.push("/nsc-not-onboarded");
    invalidateSession();
  }, []);

  return (
    <div className="pageWrapper">
      <div className={styles.brandDiv}>
        <FordLogo className={styles.brandLogo} />
      </div>
      <div className={styles.deniedTitle}>
        {props.t("AccessDeniedAsNscNotOnboarded.header")}
      </div>
      <div className={styles.deniedInfo}>
        {props.t("AccessDeniedAsNscNotOnboarded.subheader")}
      </div>
    </div>
  );
};

export default withTranslation("emp")(AccessDeniedAsNscNotOnboarded);
